<template>
  <div
    :class="[
      $style.container,
      { [$style['container--fromOther']]: !isSentByBiz },
    ]"
  >
    <div
      :class="[
        $style.container__chatMessageInfo,
        $style.chatMessageInfo,
        { [$style['chatMessageInfo--fromOther']]: !isSentByBiz },
      ]"
    >
      <p
        v-if="isSentByBiz && isReadByUser"
        :class="$style.chatMessageInfo__read"
      >
        既読
      </p>
      <p :class="$style.chatMessageInfo__time">
        <time>{{ timeString }}</time>
      </p>
    </div>
    <div
      :class="[
        $style.container__chatMessage,
        { [$style['container__chatMessage--fromOther']]: !isSentByBiz },
      ]"
    >
      <UserThumbnail
        v-if="isSentByUser"
        :personality-type="personalityType"
        :class="$style.icon"
        @click="emit('clickUserThumbnail')"
      />
      <img :src="props.message.contentURL" alt="画像" :class="$style.image" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { formatDateTimeForChatMessage } from '@/libs/utilities/formatDate'
import UserThumbnail from '@/components/atoms/UserThumbnail.vue'
import type { ImageMessage } from '@/types/app/message'
import {
  type ChatMessageUserType,
  BizChatMessageUserType,
} from './ChatMessageUserType'
import type { PersonalityType } from '@/types/app'

const emit = defineEmits<{
  (event: 'clickUserThumbnail'): void
}>()

const props = withDefaults(
  defineProps<{
    message: ImageMessage
    userType: ChatMessageUserType
    personalityType?: PersonalityType
    isReadByUser?: boolean
  }>(),
  {
    personalityType: 'A',
    isReadByUser: false,
  }
)

const isSentByUser = props.userType === 'user'
const isSentByBiz = BizChatMessageUserType.includes(props.userType)

const timeString = computed(() =>
  formatDateTimeForChatMessage(props.message.createdAt)
)
</script>

<style lang="scss" module>
.container {
  display: flex;
  justify-content: flex-end;

  &--fromOther {
    flex-direction: row-reverse;
    padding-left: 0;
  }

  &__chatMessageInfo {
    display: flex;
    flex: 0 0 120px;
    align-items: flex-end;
    justify-content: flex-end;
    flex-direction: column;
    margin-right: 8px;
    color: $color-text-and-object-low-emphasis;
    font-size: 12px;
  }

  &__chatMessage {
    flex: 0 1 auto;

    /* 他のチャットメッセージの邪魔にならないように画像が判別できる程度のサイズで表示する */
    width: min(512px, 90%);

    &:nth-child(n + 2) {
      margin-top: 8px;
      margin-right: 0;
      margin-left: 8px;
    }

    &--fromOther {
      &:nth-child(n + 2) {
        margin-right: 8px;
        margin-left: 0;
      }
    }
  }
}

.chatMessageInfo {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: $color-text-and-object-low-emphasis;
  font-size: 12px;

  &--fromOther {
    align-items: flex-start;
  }
}

.icon {
  $size: 44px;

  width: $size;
  height: $size;
  margin-top: 4px;
}

.image {
  width: 100%;
}
</style>
